var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "소방 훈련·교육 참석자 목록",
            columns: _vm.grid.columns,
            data: _vm.traningEdu.users,
            gridHeight: _vm.grid.height,
            isFullScreen: false,
            columnSetting: false,
            usePaging: false,
            editable: (_vm.editable && !_vm.disabled) || _vm.isEnvSafDept,
            selection: "multiple",
            rowKey: "sopFireFightingTraningEduUserId",
          },
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  (_vm.editable && !_vm.disabled) || _vm.isEnvSafDept
                    ? _c("c-btn", {
                        attrs: { label: "삭제", icon: "delete" },
                        on: { btnClicked: _vm.deleteTarget },
                      })
                    : _vm._e(),
                  (_vm.editable && !_vm.disabled) || _vm.isEnvSafDept
                    ? _c("c-btn", {
                        attrs: { label: "추가", icon: "add" },
                        on: { btnClicked: _vm.addTarget },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }